import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "my-environment green-bright",
  ref: "root"
}
const _hoisted_2 = { class: "my-environment__button__user flex flex-justify-between" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "my-environment__languages flex" }
const _hoisted_6 = ["onMousedown"]
const _hoisted_7 = ["onMousedown"]
const _hoisted_8 = ["onMousedown"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.currentUser)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "my-environment__button flex flex-column flex-justify-center",
          type: "button",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)), ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("b", {
              class: "ellipsis",
              title: _ctx.currentUser.firstName + " " + _ctx.currentUser.lastName
            }, _toDisplayString(_ctx.currentUser.firstName) + " " + _toDisplayString(_ctx.currentUser.lastName), 9, _hoisted_3),
            _createElementVNode("i", {
              class: _normalizeClass(["icons8-sort-down", {active : _ctx.showMenu}])
            }, null, 2)
          ]),
          (_ctx.currentCompanyDisplayName)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "my-environment__button__company ellipsis",
                title: _ctx.currentCompanyDisplayName
              }, _toDisplayString(_ctx.currentCompanyDisplayName), 9, _hoisted_4))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showMenu)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["my-environment__panel", {"with-change-button" : _ctx.impersonated || _ctx.multiCompanies}]),
          onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableLocales, (lang) => {
              return (_openBlock(), _createElementBlock("button", {
                class: _normalizeClass(["language roboto-slab", {"language--active" : lang === _ctx.currentLocale}]),
                key: lang,
                type: "button",
                onMousedown: _withModifiers(($event: any) => (_ctx.changeLang(lang)), ["prevent"])
              }, _toDisplayString(lang), 43, _hoisted_6))
            }), 128))
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleMenuItemGroupTop, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass(["my-environment__item roboto-slab", {"my-environment__item--active": _ctx.isActiveRoute(item)}]),
              key: item.title,
              type: "button",
              onMousedown: _withModifiers(($event: any) => (_ctx.navigateTo(item.route)), ["prevent"])
            }, _toDisplayString(_ctx.$t(item.title)), 43, _hoisted_7))
          }), 128)),
          _cache[9] || (_cache[9] = _createElementVNode("hr", null, null, -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItemGroupBottom, (item) => {
            return (_openBlock(), _createElementBlock("button", {
              class: _normalizeClass(["my-environment__item roboto-slab", {"my-environment__item--active": _ctx.isActiveRoute(item)}]),
              key: item.title,
              type: "button",
              onMousedown: _withModifiers(($event: any) => (_ctx.navigateTo(item.route)), ["prevent"])
            }, _toDisplayString(_ctx.$t(item.title)), 43, _hoisted_8))
          }), 128)),
          _createElementVNode("button", {
            class: "my-environment__item roboto-slab",
            type: "button",
            onMousedown: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)), ["prevent"]))
          }, _toDisplayString(_ctx.$t("MY_ENVIRONMENT.LOG_OUT")), 33),
          (_ctx.impersonated)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "my-environment__action roboto-slab",
                type: "button",
                onMousedown: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.changeUser()), ["prevent"]))
              }, [
                _cache[6] || (_cache[6] = _createElementVNode("i", { class: "icons8-user mr-05" }, null, -1)),
                _createElementVNode("span", {
                  textContent: _toDisplayString(_ctx.$t("MY_ENVIRONMENT.CHANGE_USER"))
                }, null, 8, _hoisted_9)
              ], 32))
            : (_ctx.multiCompanies)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "my-environment__action roboto-slab",
                  type: "button",
                  onMousedown: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.changeCompany()), ["prevent"]))
                }, [
                  _cache[7] || (_cache[7] = _createElementVNode("i", { class: "icons8-city-buildings mr-05" }, null, -1)),
                  _createElementVNode("span", {
                    textContent: _toDisplayString(_ctx.$t("MY_ENVIRONMENT.CHANGE_COMPANY"))
                  }, null, 8, _hoisted_10)
                ], 32))
              : _createCommentVNode("", true)
        ], 34))
      : _createCommentVNode("", true)
  ], 512))
}